import { Component } from '@angular/core';
import { RestProvider } from '../providers/rest';
import { ScreenService } from './services/screen.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'hd-landing-insight';
  landingsDetails: any;


  constructor(
    public restProvider: RestProvider,
    private screenService: ScreenService,
  ) {
}
}